import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';

import './assets/css/animate/animate.min.css';
import './assets/css/owlcarousel/assets/owl.carousel.min.css';
import './assets/css/lightbox/css/lightbox.min.css';
import './assets/css/ionicons/css/ionicons.min.css';
import './assets/css/bootstrap/css/bootstrap.min.css';
import './assets/css/style.css';

//import './assets/js/bootstrap/js/bootstrap.min.js';
//import './assets/js/jquery/jquery.min.js';
//import './assets/js/jquery/jquery-migrate.min.js';
//import './assets/js/popper/popper.min.js';
//import './assets/js/easing/easing.min.js';
//import './assets/js/counterup/jquery.waypoints.min.js';
//import './assets/js/counterup/jquery.counterup.js';
//import './assets/js/owlcarousel/owl.carousel.min.js';
//import './assets/js/lightbox/js/lightbox.min.js';
//import './assets/js/typed/typed.min.js';
 
//import './assets/js/contactform/contactform.js';

//import './assets/js/main.js'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
